import React, { useEffect } from "react";
import { connect } from "react-redux";

import "./index.css";

const TimeLineResume = (props) => {
  const { data, distance, setDistance, activePoint, setActivePoint } = props;

  const focusYear = (indexItem) => {
    let newDistance = (indexItem * 100) / data.years.length;
    setDistance(newDistance + 4);
    setActivePoint(indexItem);
  };

  const onClick = (index) => {
    const element = document.getElementById(`year-${index}`)
      , container = document.getElementById("history_container")
    // , resumeContainer = document.getElementById('history-resume');
    if (element && container) {
      // let sizes = resumeContainer.getBoundingClientRect();

      let prev = 0
      for (let card = 0; card < index; card++) {
        const cardItem = document.getElementById(`year-${card}`)
          , cardSizes = cardItem.getBoundingClientRect()
          , cardType = cardItem.getAttribute('type')
          , extra = (window.innerHeight / 100)

        prev += cardSizes.width + ((cardType === 'card' ? 15 : 10) * extra)
      }
      // if (index !== 0) prev += (sizes.width)

      let scrollWidth = prev

      container.scroll({
        left: scrollWidth + index,
        behavior: "smooth",
      });
    }
    focusYear(index);
  };

  useEffect(() => {
    onClick(activePoint)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activePoint])


  useEffect(() => {
    // let distancePoint = 100 / (data.years.length + 1);

    setDistance(4);
    setActivePoint(0);

    return () => { };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="time-line-section">
      <div className="box_dates">
        <span className="initial_point" />
        <span className="final_point" />
        <span className="time-line-line-gray" style={{ width: "100%" }} />
        <span
          className="time-line-line-black"
          style={{
            width: `${distance}%`,
          }}
        />
        {data.years.map((item, index) => {
          return (
            <div className="box_container" key={index}>
              <div className="date">{item}</div>
              {activePoint === index ? (
                <span
                  className={`${"oval_white"}`}
                  onClick={() => onClick(index)}
                >
                  <span className="oval_red" />
                </span>
              ) : (
                <span
                  className={`${"oval_black"}`}
                  onClick={() => onClick(index)}
                />
              )}
            </div>
          );
        })}
        {/* <div className="dash-line">
        <svg width="100%">
          <g stroke="#B9B9B9" stroke-width="10">
            <path stroke-dasharray="1.1" d="M0 0 l500 0" />
          </g>
        </svg>
      </div> */}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  settings: state.settings,
});

export default connect(mapStateToProps)(TimeLineResume);
